import { classDuration, timeSlotInterval } from "constants/variables";

export const getLengthOptions = (chosenSticker, length = timeSlotInterval.minutes_15) => {
    let defaultLength = '';
    const lengthOptions = [];
    const increment =
    length === timeSlotInterval.minutes_15
      ? classDuration.min.minutesInterval_15
      : classDuration.min.minutesInterval_5;
        
    for (let i = increment; i < classDuration.max; i += length) {
        const hour = Math.floor(getHours(i));
        const minutes = Math.round(i % 60);
        const minutesText = minutes > 0 ? minutes === timeSlotInterval.minutes_5 ? `0${minutes} m` : `${minutes} m` : '';
        const label = (hour > 0 ? `${hour} h ` : '') + minutesText;

        lengthOptions.push({ value: getHours(i), label, entity: "length" });
        
        if (Math.round(getMinutes(chosenSticker?.length)) === i) {
            defaultLength = { value: getHours(i), label, entity: "length" }
        }
    }
    return [lengthOptions, defaultLength];
}

export const getBackgroundColor = (event, colorBy = 'levels') => {
    let colors = [];
    switch (colorBy) {
        case 'teachers':
            colors = event.teacherColors  || [];
            break;
        case 'styles':
            colors = event.styleColors || [];
            break;
        case 'levels':
        default:
            colors = event.levels || [];
            break;
    }

    if (colors.length < 2) {
        return colors[0] || '#D9D9D9';
    }
    
    let background = `linear-gradient(${180}deg, `;
    colors.forEach((color, i) => {
        i !== colors.length - 1 ? background += `${color}, ` : background += `${color})`
    })
    return background
}

export const getTimeSlotInterval = (length) => {
    const minutes = Math.round(getMinutes(length));

    if (minutes % timeSlotInterval.minutes_5 === 0 && minutes % timeSlotInterval.minutes_15 !== 0) {
        return timeSlotInterval.minutes_5
    }
        
    return timeSlotInterval.minutes_15
}

export const getMinutes = (value) => value * 60;
export const getHours = (value) => value / 60;
export const getHourLengthFromMilliseconds = (value) => value / 60000 / 60;

/**
 * Collator instance for natural sorting with numeric support
 * Created once at module level for performance
 */
const collator = new Intl.Collator('en-US', { 
  numeric: true, 
  sensitivity: 'base' 
});

/**
 * Natural sort function using Intl.Collator for proper numeric sorting
 * Example: ['item1', 'item10', 'item2'] -> ['item1', 'item2', 'item10']
 * @param {Array} arr - Array of objects to sort
 * @param {string} fieldName - Name of the field to sort by
 * @returns {Array} - Sorted array
 */
export const naturalSort = (arr, fieldName) => {
  return [...arr].sort((a, b) => collator.compare(a[fieldName], b[fieldName]));
};

/**
 * Natural sort comparator function for use with Array.sort()
 * Example: arr.sort((a, b) => naturalCompare(a.label, b.label))
 * @param {string} a - First string to compare
 * @param {string} b - Second string to compare
 * @returns {number} - Comparison result
 */
export const naturalCompare = (a, b) => {
  return collator.compare(a, b);
};

export const calculateAge = (birthDate) => {
    if (!birthDate) {
        return null;
    }

    const parsedDate = new Date(birthDate);
    if (Number.isNaN(parsedDate.getTime())) {
        return null;
    }

    const today = new Date();
    let age = today.getFullYear() - parsedDate.getFullYear();
    const monthDiff = today.getMonth() - parsedDate.getMonth();
    const dayDiff = today.getDate() - parsedDate.getDate();

    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        age -= 1;
    }

    return age >= 0 ? age : null;
};